module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "el-button el-button--default",
    attrs: {
      "to": {
        name: _vm.routeName
      }
    }
  }, [_vm._v("Cancelar\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-814dc53e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/form/CancelButton.vue
// module id = 774
// module chunks = 2